// @core/api/endpoints/license/get_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Get license by ID
 * Retrieves complete details of a license including entitlements, activation status, hardware binding, and validity period.
 */
export async function GetLicense(
  license_id: string,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.get<LicenseResponse>(requestPath, { ...requestOptions });
}
